#import "../../../../../../core-entity/graphql/fragments/contact-for-core-entity-fragment.graphql"

query GetRelatedContacts(
    $id: ID!
    $first: Int
    $after: String
    $formerOnly: Boolean
    $search: String
    $sortBy: PeepRelatedPeepSortType
) {
    account(id: $id) {
        id
        contacts(
            first: $first
            after: $after
            formerOnly: $formerOnly
            search: $search
            sortBy: $sortBy
        ) {
            totalCount
            pageInfo {
                hasNextPage
                endCursor
            }
            primary {
                id
                name
            }
            edges {
                node {
                    ...ContactForCoreEntityFragment
                }
                isFormer
                relationshipNote
            }
        }
    }
}
